import {createReducer} from '@reduxjs/toolkit'
import {
  closeListLayoutItems,
  hideEventBadge,
  hideRibbons,
  openListLayoutItem,
  showEventBadge,
  showRibbons,
} from '../actions/layout'
import {Layout} from '../types/state'

const defaultState: Layout = {
  listItemOpened: '',
  forceShowRibbon: null,
  forcedEventBadge: null,
}

export const layout = createReducer(defaultState, builder =>
  builder
    .addCase(openListLayoutItem, (state, {payload}) => {
      state.listItemOpened = payload
    })
    .addCase(closeListLayoutItems, state => {
      state.listItemOpened = ''
    })
    .addCase(showRibbons, (state, {payload}) => {
      state.forceShowRibbon = payload ?? null
    })
    .addCase(hideRibbons, state => {
      state.forceShowRibbon = null
    })
    .addCase(showEventBadge, (state, {payload}) => {
      state.forcedEventBadge = payload
    })
    .addCase(hideEventBadge, state => {
      state.forcedEventBadge = null
    }),
)
